import { render, staticRenderFns } from "./userMess.vue?vue&type=template&id=76e67e1c&scoped=true&"
import script from "./userMess.vue?vue&type=script&lang=js&"
export * from "./userMess.vue?vue&type=script&lang=js&"
import style0 from "./userMess.vue?vue&type=style&index=0&id=76e67e1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e67e1c",
  null
  
)

export default component.exports